import styled from 'styled-components';

export const ExportExcelWrapper = styled.div`
  display: flex;

  button {
    margin-left: 16px;
  }
`;
